import React, { useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FilterContainer, InputFilter, Option, SelectFilter, TD } from '../../../styles/Table.styled';
import { showColumn, getAlignPosition, bailleursTries } from '../../../shared/utility';
import { PrimaryBtnOutlineAction, BtnFilter } from '../../../styles/Common';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { CTooltip } from '../../UI/CTooltip/CTooltip';
import { useTheme } from 'styled-components';

function TableFilters(props) {
    const {t} = useTranslation();
    const { allBailleurs, filters, filtersChange, applyFilters, entityUid, columns, listOfRoles, handleReset, userType} = props;
    const theme = useTheme(); 
    const inputChangeHandler = (e) => {
        let key = e.target.name;
        let newFilters = {
            ...filters,
            [key]: e.target.value
        }
        filtersChange(newFilters);
        applyFilters(newFilters);
    }

    return (
        <>
            <tr style={{display: props.show ? 'table-row' : 'none'}}>
                <TD></TD>
                {columns.filter(row => row.show == true).map(column => {
                    switch (column.field) {
                        case "userName":
                            return <TD style={{ display: !showColumn(columns, "userName") && 'none' }} >
                                <FilterContainer>
                                    <InputFilter
                                        placeholder={t("invoiceList:first_name", "Abcdef")}
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.userName || ''}
                                        name="userName"
                                        type="text"
                                        autoComplete="off" />
                                </FilterContainer>
                            </TD>
                     
                        case "urn:younov:displayname":
                            return <TD style={{ display: !showColumn(columns, "urn:younov:displayname") && 'none' }} >
                                <FilterContainer>
                                    <InputFilter
                                        placeholder={t("invoiceList:last_name", "Smith Alice")}
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.given_name || ''}
                                        name="given_name"
                                        type="text"
                                        autoComplete="off" />
                                </FilterContainer>
                            </TD>
                        case "email":
                            return <TD style={{ display: !showColumn(columns, "email") && 'none' }} >
                                <FilterContainer>
                                    <InputFilter
                                        placeholder={t("invoiceList:login", "exemple@domaine.com")}
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.email || ''}
                                        name="email"
                                        type="text"
                                        autoComplete="off" />
                                </FilterContainer>
                            </TD>

                        case "phoneNumber":
                            return <TD style={{ display: !showColumn(columns, "phoneNumber") && 'none' }} >
                                <FilterContainer>
                                    <InputFilter
                                        placeholder={t("invoiceList:telephone_number", "0123456789")}
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.phoneNumber || ''}
                                        name="phoneNumber"
                                        type="text"
                                        autoComplete="off" />
                                </FilterContainer>
                            </TD>

                        case "lockoutEnd":
                            return <TD style={{ display: !showColumn(columns, "lockoutEnd") && 'none' }} >
                                <FilterContainer>
                                    <SelectFilter
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.active || ''}
                                        name="active"
                                    >
                                        <Option value=""></Option>
                                        <Option value="1">{t('tableHead:yes', 'Oui').toUpperCase()}</Option>
                                        <Option value="0">{t('tableHead:no', 'Non').toUpperCase()}</Option>
                                    </SelectFilter>
                                </FilterContainer>
                            </TD>

                        case "role":
                            return <TD style={{ display: !showColumn(columns, "role") && 'none' }} >
                                        <FilterContainer>
                                            <SelectFilter
                                                onChange={(e) => inputChangeHandler(e)}
                                                value={filters?.role || ''}
                                                name="role"
                                            >
                                                <Option value=""></Option>
                                                {entityUid ?
                                                    (
                                                     listOfRoles.filter((item, index) => item?.type == "Bailleurs").map((item, index) =>
                                                            <Option key={index} value={item?.roleId}>{item?.libelle}</Option>)

                                                    )
                                                    :
                                                    (
                                                listOfRoles.filter((item, index) => ["Bailleurs", "OperateurBackOffices"].includes(item.type)).map((item, index) =>
                                                            <Option key={index} value={item?.roleId}>{item?.libelle}</Option>)
                                                    )
                                                }
                                            </SelectFilter>
                                        </FilterContainer>
                                    </TD>
                            
                        case "permission":
                            return <TD style={{ display: !showColumn(columns, "permission") && 'none' }} >
                                <FilterContainer>
                                    <SelectFilter
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.permission || ''}
                                        name="permission"
                                    >
                                        <Option value=""></Option>
                                        <Option value="ModificationAdresse">ModificationAdresse</Option>
                                        
                                        {entityUid ?
                                            (<>
                                                <Option value={"GestionDerive"}>GestionDerive</Option>
                                                <Option value={"AjoutJustificatif"}>AjoutJustificatif</Option>
                                            </>
                                            )
                                            :
                                            (
                                            <>
                                                <Option value={"GestionDerive"}>GestionDerive</Option>
                                                    <Option value={"AjoutJustificatif"}>AjoutJustificatif</Option>
                                                    <Option value={"ControleNiveau2"}>ControleNiveau2</Option>
                                                    <Option value={"ControleNiveau1"}>ControleNiveau1</Option>
                                                    <Option value={"Saisie"}>Saisie</Option>
                                                    <Option value={"Exploitation"}>Exploitation</Option>
                                                    <Option value={"PilotageNiveau1"}>PilotageNiveau1</Option>
                                                    <Option value={"PilotageNiveau2"}>PilotageNiveau2</Option>
                                            </>
                                            )
                                        }
                                    </SelectFilter>
                                </FilterContainer>
                            </TD>
                        case "BailleurName":
                            return <TD style={{ display: !showColumn(columns, "BailleurName") && 'none' }} >
                                <FilterContainer>
                                    <SelectFilter
                                        onChange={(e) => inputChangeHandler(e)}
                                        value={filters?.BailleurName || ''}
                                        name="BailleurName"
                                    >
                                        
                                       
                                        {!entityUid ?
                                            (
                                                <>
                                                    <Option value=""></Option>
                                                    <Option value="younov">BackOffice</Option>
                                                    {bailleursTries(allBailleurs).map((item, index) =>
                                                        <Option key={index} value={item.id}>{item?.raisonSociale.toUpperCase()}</Option>)}
                                                </>
                                            ) :
                                            (
                                                <Option value={entityUid}>{allBailleurs.filter((item,i) => item.id == entityUid)[0]?.raisonSociale?.toUpperCase()}</Option>
                                            )
                                        }
                                    </SelectFilter>
                                </FilterContainer>
                            </TD>
                    }
                })}
       
                <TD>
                    <BtnFilter onClick={() => handleReset()}>
                        <CTooltip title={"Réinitialiser les filtres"}>
                            <FilterListOffIcon style={{ color: "#fff" }} />
                        </CTooltip>
                    </BtnFilter>
                </TD>
            </tr>
            <tr></tr>
        </>
    )
}

export default TableFilters
